<template>
  <!-- 历次党代会查看更多二级页 -->
  <div>
    <div class="ldmeet-content">
      <!--面包屑-->
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>党史学习</el-breadcrumb-item>
          <el-breadcrumb-item>历次党代会</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ldmeet-cont">
        <div class="ldmeet-left">
          <LdddhNav></LdddhNav>
        </div>
        <div class="ldmeet-right">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import LdddhNav from "./lcddh/LdddhNav.vue";
export default {
  components: {
    LdddhNav,
  }
};
</script>
<style lang="scss" scoped>
  @import "../../assets/dmeet.css";
.ldmeet-content {
  width: 1200px;
  margin: 30px auto;
  .ldmeet-cont {
    margin: 20px 0;
    position: relative;
    .ldmeet-left {
      width: 220px;
      height: auto;
    }
    .ldmeet-right {
      position: absolute;
      left: 270px;
      right: 0;
      top: 0;
      bottom: 0;
      overflow-y: auto;
    }
  }
}
</style>